<template>
  <CustomModal
    id="incomplete-acceptance-criteria-modal"
    width="515"
    modalClass="custom-modal_xl incomplete-checklist-modal"
    @onClosed="onCancel"
  >
    <template #header>
      <BaseHeading
        level="3"
        className="incomplete-checklist-modal__heading"
      >
        Complete Acceptance Criteria
      </BaseHeading>
    </template>

    <template #body>
      <div class="incomplete-checklist-modal__body">
        <BaseSubHeading
          size="large"
          weight="400"
        >
          This Item contains incomplete Acceptance Criteria.
        </BaseSubHeading>
        <div class="incomplete-checklist-modal__list custom-scroll">
          <!-- Content comes from the same sanitized editor HTML rendered by the Acceptance Criteria pane. -->
          <div v-html="incompleteCriteriaHtml"></div>
        </div>
        <BaseSubHeading
          size="large"
          weight="400"
        >
          Please confirm you'd like to check off all Acceptance Criteria and close this Definition
          of Done.
        </BaseSubHeading>
      </div>
    </template>

    <template #footer>
      <ControlButtons
        class="modal-incomplete-checklist__buttons"
        @save="onConfirm"
        @cancel="onCancel"
      >
        <template #save> Confirm </template>
      </ControlButtons>
    </template>
  </CustomModal>
</template>

<script setup lang="ts">
/** Displays only unfinished Acceptance Criteria before the user completes them through DoD. */
import { computed } from "vue"

import ControlButtons from "@/components/ControlButtons/index.vue"
import CustomModal from "@/components/Modal/index.vue"

import { StructuredDescription } from "@/models"

const props = defineProps<{
  acceptanceCriteria?: StructuredDescription
}>()

const emit = defineEmits(["confirm", "cancel"])

const onConfirm = () => emit("confirm")
const onCancel = () => emit("cancel")

const incompleteCriteriaHtml = computed(() => {
  const document = new DOMParser().parseFromString(
    props.acceptanceCriteria?.html ?? "",
    "text/html"
  )
  const lists = Array.from(document.querySelectorAll<HTMLElement>('ul[data-type="taskList"]'))
  lists.forEach(list => {
    list.querySelectorAll<HTMLElement>('li[data-checked="true"]').forEach(item => item.remove())
  })
  return lists
    .filter(list => list.children.length)
    .map(list => list.outerHTML)
    .join("")
})
</script>
